import script from "./RedeemTokenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemTokenModal.vue?vue&type=script&setup=true&lang=js"

import "./RedeemTokenModal.vue?vue&type=style&index=0&id=0e94f4e9&scoped=true&lang=css"
script.__scopeId = "data-v-0e94f4e9"

export default script